"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { ICampaignLog } from "@/interfaces/campaign-logs.interface";
import campaignLogService from "@/services/campaign-log.service";
import { FilterType, IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<ICampaignLog> | null>;

export interface Props extends RequestPagination {
  campaignId: number;
  scheduleDate: string;
  filters: IFilter<ICampaignLog>[];
}

type GetAllSwrParams = [string, number, number, IFilter<ICampaignLog>[]];

const useGetCampaignLogs = ({
  campaignId,
  scheduleDate,
  pageNumber,
  pageSize,
  filters,
}: Props): Return => {
  // Decodifica o formato da data, se necessário
  const decodedScheduleDate = decodeURIComponent(scheduleDate);

  // Filtros fixos
  const fixedFilters: IFilter<ICampaignLog>[] = [
    { property: "scheduleDate", filterType: FilterType.Equals, value: decodedScheduleDate },
    { property: "campaignId", filterType: FilterType.Equals, value: campaignId },
  ];

  const normalizedFilter = normalizeSingleFilterFormData(filters, "contactName");

  const filtersFormat = [...normalizedFilter, ...fixedFilters];

  const fetcher = useSWR<PaginatedResponse<ICampaignLog>, Error, GetAllSwrParams>(
    [SWR_KEYS.getCampaigns, pageNumber, pageSize, filtersFormat],
    ([, _pageNumber, _pageSize, _filters]) =>
      campaignLogService.filter(_filters, { pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetCampaignLogs;
